module.exports = __webpack_public_path__ + "static/quality_infras_icon-5be4d8ceff2f79958cff6900a327edc1.svg";